module.exports = __webpack_public_path__ + "img/13.d13196d0.jpg";